module.exports = __webpack_public_path__ + "img/list32.a13d7958.jpeg";